import React, { Component } from 'react';
import ItemDetailPreview from './item-detail';
import plusIcon from 'src/assets/images/common/plus.svg';
import noProductImage from 'src/assets/images/product/no-product-image.png';

class ProductItemPreview extends Component<ComposedProps, State> {
  render() {
    const { product, numberOfRecommendProduct, index, bundleStyle, tenantApp, selectedProducts } =
      this.props;
    const numberOfProduct = numberOfRecommendProduct < 6 ? numberOfRecommendProduct : 5;
    return (
      <React.Fragment>
        <div
          key={product.id}
          className="product-image-wrapper"
          style={{ width: `calc(100%/${numberOfProduct})` }}>
          <div className="product-images">
            <div
              className={`product-image product-image--${
                selectedProducts[product.id] && selectedProducts[product.id].selected
                  ? 'has-border'
                  : 'blur'
              }`}>
              {Object.values(product.images).length > 0 ? (
                <img
                  className="product-image-img"
                  src={String(Object.values(product.images)[0])}
                  alt="productImage"
                />
              ) : (
                <img className="product-image-img" src={noProductImage} alt="productImage" />
              )}
            </div>
            <img
              src={plusIcon}
              alt="plus"
              style={{ visibility: index + 1 >= numberOfRecommendProduct ? 'hidden' : 'visible' }}
            />
          </div>
          {bundleStyle !== 'style1' && (
            <ItemDetailPreview
              product={product}
              index={index}
              selectedProducts={selectedProducts}
              updateSelectedProduct={this.props.updateSelectedProduct}
              tenantApp={tenantApp}
              bundleStyle={bundleStyle}
            />
          )}
        </div>
      </React.Fragment>
    );
  }
}
export default ProductItemPreview;
